import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { TextFieldProps } from '@material-ui/core/TextField';
import { ICustomer, themeTypes } from 'shared-types/index';

export interface IStringEvent {
  name: string;
  value: string;
}

export enum FlagPhonePickerStyle {
  diary = 'diary',
  abc = 'abc',
  widget = 'widget',
}

export interface IHandlers {}

export interface IProps {
  isNewCustomerForm?: boolean;
  isPhoneIcon?: boolean;
  uiStyle?: FlagPhonePickerStyle;
  theme?: {
    type: themeTypes;
  };
  overrideStyles?: IOverrideStyles;
  value: string;
  handleBlur: (e: any) => void;
  handleChange: (e: { target: IStringEvent }) => void;
  country: string;
  searchCustomer: (e: { target: IStringEvent }, countryCode?: string) => void;
  customers: ICustomer[];
  handleWholeFormChangeForAutocomplete: (value: ICustomer) => void;
  forceValidation: boolean;
  touched?: boolean;
  errors?: string;
  maxLength?: number;
  label?: string;
  forceTouched?: boolean;
  classPrefix?: string;
  skipAutoComplete?: boolean;
  usePlaceholderForLabel?: boolean;
  isDropDownListMoveUp?: boolean;
  disabled?: boolean; // for DM disable phone input with viewBooking
  name?: string
  required?: boolean
  autoFocusOnLoad?: boolean;
  shouldSkipAutoFocus?: () => boolean;
  includeAutocomplete: boolean; // if false, the autocomplete will not be used
}

export interface IValidationHelperProps {
  isNewCustomerForm?: boolean;
  isPhoneIcon?: boolean;
  customerCountry: string;
  customerPhone: string;
  customerSelected?: (customer: ICustomer) => void;
  // if customerSearch is null, the autocomplete will not be used
  customerSearch?: (phone: string, countryCode?: string) => Promise<ICustomer[]>;
  handlePhoneChange?: (phone: string, phoneWithoutPrefix?: string) => void;
  setPhoneValid?: (flag: boolean) => void;
  setPhoneTouched?: (flag: boolean) => void;
  setPhoneWithoutPrefix?: (phone: string) => void;
  shouldSkipAutoFocus?: () => boolean;

  validationError?: string;
  maxLength?: number;
  label?: string;
  forceTouched?: boolean;
  classPrefix?: string;
  skipAutoComplete?: boolean;
  usePlaceholderForLabel?: boolean;
  isDropDownListMoveUp?: boolean;
  disabled?: boolean; // for DM disable phone input with viewBooking
  overrideStyles?: IOverrideStyles;
  name?: string;
  uiStyle?: FlagPhonePickerStyle;
  autoFocusOnLoad?: boolean;
}
export interface IOverrideStyles {
  focusedColor?: string;
  phoneIcon?: Record<string, string>
}

export interface IDeprecatedAutoCompleteProps {
  textInputClasses: ClassNameMap<string>;
  labelText: string | JSX.Element;
  value: string;
  name: string;
  placeholderText: string;
  helperText: string;
  isRequired: boolean;
  error: boolean;
  disabled: boolean;
  inputProps: {maxLength: number} | {maxLength?: undefined}
  customers: ICustomer[];
  country: string;
  TextFieldComponent: React.ComponentType<TextFieldProps>;
  handleWholeFormChangeForAutocomplete: (value: ICustomer) => void;
  handleChange: (evt: any) => void;
  handleBlur: (e: any) => void;
}